import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || (process.env.NODE_ENV === 'test' ? 'test-api-key' : undefined),
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || (process.env.NODE_ENV === 'test' ? 'test.firebaseapp.com' : undefined),
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || (process.env.NODE_ENV === 'test' ? 'test-project' : undefined),
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID || (process.env.NODE_ENV === 'test' ? '1:123:web:123' : undefined),
  measurementId: "G-L2Y3HRWPV8"
};

const app = initializeApp(firebaseConfig);
export { app };
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app, "australia-southeast1");

// Optional: connect to local emulators when explicitly enabled for local development
// SECURITY: Only connect to emulators in development mode with explicit flag
// This ensures production builds NEVER connect to localhost emulators
const isDevelopment = process.env.NODE_ENV === 'development';
const useEmulators = process.env.REACT_APP_USE_FIREBASE_EMULATORS === 'true';
const isLocalhost = typeof window !== 'undefined' && (
  window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1'
);

if (isDevelopment && useEmulators && isLocalhost) {
  console.log('[Firebase] Connecting to local emulators');
  // Use 127.0.0.1 instead of localhost to avoid IPv6 issues on Windows
  try {
    // Auth Emulator
    connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
  } catch (_) {}
  try {
    // Firestore Emulator
    connectFirestoreEmulator(db, '127.0.0.1', 8080);
  } catch (_) {}
  try {
    // Functions Emulator
    connectFunctionsEmulator(functions, '127.0.0.1', 5001);
  } catch (_) {}
} else if (useEmulators && !isLocalhost) {
  console.error('[Firebase] SECURITY WARNING: Emulator mode requested but not on localhost - ignoring');
} else {
  console.log('[Firebase] Connecting to production Firebase');
}
export default app;